module.exports = __webpack_public_path__ + "assets/shape.83693e3f476841b9418684848982a65c.png";